import React from 'react';
import PropTypes from 'prop-types';

import TableHeaderSortIcon from './TableHeaderSortIcon';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    sortKey: PropTypes.oneOf(['last_name', 'email', 'role_token', 'join_date', 'active_at']),
    sortAsc: PropTypes.bool,
    sortNameFxn: PropTypes.func,
    sortRoleFxn: PropTypes.func,
    sortJoinDateFxn: PropTypes.func,
    sortActiveAtFxn: PropTypes.func,
};

const defaultProps = {
    children: null,
    className: '',
    sortKey: '',
    sortAsc: true,
    sortNameFxn: null,
    sortEmailFxn: null,
    sortRoleFxn: null,
    sortJoinDateFxn: null
};

class UserTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const sortIconElem =  <TableHeaderSortIcon className="margin-left-md" asc={this.props.sortAsc} />;

        return (
            <table className={`collabs-table ${this.props.className}`}>
                <thead>
                    <tr className="collabs-header">
                        <th className="d-none d-sm-table-cell col-sm-1 cell">
                            <span className="sr-only">User Picture</span>
                        </th>
                        <th className="col-3 col-sm-2 cell">
                            { !!this.props.sortNameFxn ?
                                <span role="button" onClick={this.props.sortNameFxn}>Name</span>
                                :
                                'Name'
                            }
                            { this.props.sortKey === 'last_name' && sortIconElem }
                        </th>
                        <th className="col-2 cell">
                            { !!this.props.sortNameFxn ?
                                <span role="button" onClick={this.props.sortEmailFxn}>Email</span>
                                :
                                'Email'
                            }
                            { this.props.sortKey === 'email' && sortIconElem }
                        </th>
                        <th className="col-2 cell">
                            { !!this.props.sortRoleFxn ?
                                <span role="button" onClick={this.props.sortRoleFxn}>Role</span>
                                :
                                'Role'
                            }
                            { this.props.sortKey === 'role_token' && sortIconElem }
                        </th>
                        <th className="col-2 cell">
                            { !!this.props.sortJoinDateFxn ?
                                <span role="button" onClick={this.props.sortJoinDateFxn}>Join Date</span>
                                :
                                'Join Date'
                            }
                            { this.props.sortKey === 'join_date' && sortIconElem }
                        </th>
                        <th className="col-2 cell">
                            { !!this.props.sortActiveAtFxn ?
                                <span role="button" onClick={this.props.sortActiveAtFxn}>Last Active</span>
                                :
                                'Last Active'
                            }
                            { this.props.sortKey === 'active_at' && sortIconElem }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.children}
                </tbody>
            </table>
        )
    }
}

UserTable.propTypes = propTypes;
UserTable.defaultProps = defaultProps;

export default UserTable;